module.exports = __webpack_public_path__ + "img/bill_3.ffcdd1d3.png";